module.exports = __webpack_public_path__ + "static/media/thum4.4814b339.jpg";